import React from 'react';
import styled from '@emotion/styled';
import artePropTypes from '../../propTypes';
import { mediaQueries, remCalc, srOnly } from '../../css';

const StyledList = styled('ul')(({ theme }) => ({
    display: 'flex',
    margin: 0,
    padding: remCalc(10, 0),
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    [mediaQueries.medium]: {
        padding: remCalc(20, 0),
    },
    borderTopColor: theme.global.dividerColor,
    borderBottomColor: theme.global.dividerColor,
}));

const StyledItem = styled('li')(() => ({
    width: '33%',
    [mediaQueries.medium]: {
        width: '15%',
    },
    [mediaQueries.xlarge]: {
        margin: remCalc(0, 20),
        width: 'auto',
    },
}));

const StyledLink = styled('a')(({ partner }) => {
    const retina = global.devicePixelRatio && global.devicePixelRatio > 1 ? '@2x' : '';
    const url = `${process.env.CDN_URL}/img/next-footer/sprite-footer-arte-hover${retina}.png`;
    const style = {
        display: 'block',
        margin: '0 auto',
        height: remCalc(42),
        background: `transparent url(${url}) no-repeat`,
        backgroundSize: '1295px 42px',
        opacity: 0.6,
        ':hover,:focus': {
            opacity: 1,
        },
    };
    let partnerStyle = {};
    switch (partner) {
        case 'zdf':
            partnerStyle = {
                width: '51px',
                backgroundPosition: '0 0',
            };
            break;
        case 'ard':
            partnerStyle = {
                width: '66px',
                backgroundPosition: '-94px 0',
            };
            break;
        case 'ffl':
            partnerStyle = {
                width: '101px',
                backgroundPosition: '-1127px 0',
            };
            break;
        case 'rtbf':
            partnerStyle = {
                width: '60px',
                backgroundPosition: '-300px 0',
            };
            break;
        case 'orf':
            partnerStyle = {
                width: '52px',
                backgroundPosition: '-400px 0',
            };
            break;
        case 'rts':
            partnerStyle = {
                width: '68px',
                backgroundPosition: '-500px 0',
            };
            break;
        case 'ceskatelevize':
            partnerStyle = {
                width: '55px',
                backgroundPosition: '-600px 0',
            };
            break;
        case 'rte':
            partnerStyle = {
                width: '35px',
                backgroundPosition: '-700px 0',
            };
            break;
        case 'rai':
            partnerStyle = {
                width: '33px',
                backgroundPosition: '-800px 0',
            };
            break;
        case 'yle':
            partnerStyle = {
                width: '32px',
                backgroundPosition: '-900px 0',
            };
            break;
        case 'ert':
            partnerStyle = {
                width: '61px',
                backgroundPosition: '-1000px 0',
            };
            break;
        default:
            partnerStyle = {};
    }
    return {
        ...style,
        ...partnerStyle,

        '.sr-only': srOnly,
    };
});

export const PartnerSection = ({ partners }) => (
    <StyledList>
        {partners.map(partner => (
            <StyledItem key={partner.href}>
                <StyledLink partner={partner.id} href={partner.href} title={partner.label}>
                    <span className="sr-only">{partner.label}</span>
                </StyledLink>
            </StyledItem>
        ))}
    </StyledList>
);

PartnerSection.propTypes = artePropTypes.partnerFooter.isRequired;

export default PartnerSection;
